export default __webpack_public_path__ + "static/media/screens.ce8d288d.webp";